import { executeNetworkAsync } from "../../helper/handler/network";
import { clientAxiosInstance } from "../../types/swrFetcher";

export const signupPasswordTokenController = async (password: string) => {
  const networkCall = async () =>
    await clientAxiosInstance().post<{ token: string }>(
      "/api/auth/signup-password-token",
      { password }
    );

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result as { token: string } | null, error] as const;
};
